import React, { Component } from 'react';
import {
  Col,
  Glyphicon,
  Modal,
  PageHeader,
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';
import './ListLocations.css';
import { Link } from 'react-router-dom';
import Loader from '../components/atoms/Loader';

function renderLocationsList(locations) {
  return locations.map((location) => (
    <ListGroupItem key={location.id} header={`${location.id}`}>
      {location.prettyName}
      &nbsp; &nbsp; &nbsp;
      <Glyphicon glyph="user" />
      {location.route}
      <br />
      <strong
        style={{
          color: location.status === 'LIVE' ? '#74aa50' : '#FF123e',
        }}
      >
        {location.status}
      </strong>
      &nbsp; &nbsp; &nbsp; Allocation:{' '}
      <strong>{location.prod === 1 ? 'ON' : 'OFF'}</strong>
      <br />
      <Link to={`/locations/detail/${location.id}`}>Detail</Link>
      &nbsp; &nbsp; &nbsp;
      <Link to={`/locations/inventory/${location.id}`}>Inventory</Link>
      &nbsp; &nbsp; &nbsp;
      <Link to={`/locations/health/${location.id}`}>Fridge Health</Link>
      <br />
    </ListGroupItem>
  ));
}

export default class ListLocation extends Component {
  filterFridges() {
    const curLocations = JSON.parse(
      localStorage.getItem('locationsLoaded'),
    )?.locations;
    let newLocations = this.props.locations;
    if (
      Array.isArray(curLocations) &&
      newLocations.length != curLocations.length &&
      !this.props.lazyLoad
    ) {
      newLocations = newLocations.concat(curLocations);
    }
    const filterParameters = this.props.filters;
    const filterKeys = Object.keys(this.props.filters);
    const toFilter = [];
    for (let i = 0; i < filterKeys.length; i++) {
      if (filterParameters[filterKeys[i]] !== '') {
        toFilter.push(filterKeys[i]);
      }
    }
    const filteredFridges = [];
    for (let i = 0; i < newLocations.length; i++) {
      const thisLocation = newLocations[i];
      let canFilter = true;
      for (let j = 0; j < toFilter.length; j++) {
        if (toFilter[j] === 'searchBox') {
          if (
            ('id' in thisLocation &&
              thisLocation.id
                .toString()
                .toLowerCase()
                .includes(
                  this.props.filters.searchBox.toString().toLowerCase(),
                )) ||
            ('prettyName' in thisLocation &&
              thisLocation.prettyName
                .toString()
                .toLowerCase()
                .includes(
                  this.props.filters.searchBox.toString().toLowerCase(),
                ))
          ) {
            canFilter = canFilter && true;
          } else {
            canFilter = canFilter && false;
            break;
          }
        } else if (
          toFilter[j] in thisLocation &&
          this.props.filters[toFilter[j]]?.toString().toLowerCase() ===
            thisLocation[toFilter[j]]?.toString().toLowerCase()
        ) {
          canFilter = canFilter && true;
        } else {
          canFilter = canFilter && false;
          break;
        }
      }
      if (canFilter) {
        filteredFridges.push(thisLocation);
      }
    }
    if (this.props.filters.route === '') {
      filteredFridges.sort(function (a, b) {
        return a.id.localeCompare(b.id);
      });
    } else {
      filteredFridges.sort(function (a, b) {
        if (a.status === b.status) {
          if (a.status === 'LIVE') {
            // TODO: rewrite condition to prevent `no-nested-ternary` error
            // eslint-disable-next-line no-nested-ternary
            return a.stop < b.stop ? -1 : a.stop > b.stop ? 1 : 0;
          }
          return a.id.localeCompare(b.id);
        }
        return a.status.localeCompare(b.status);
      });
    }
    return filteredFridges;
  }

  handleLocationClick = (event) => {
    event.preventDefault();
    this.props.history.push(event.currentTarget.getAttribute('href'));
  };

  renderLocations() {
    return (
      <div className="locations">
        <PageHeader>Locations</PageHeader>
        {this.props.isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="row">
              <div className="col-sm-4 col-xs-12">
                <input
                  type="text"
                  name="searchBox"
                  id="searchBox"
                  value={this.props.filters.searchBox}
                  onChange={this.props.handleFilterChange}
                  placeholder="Filter fridges"
                  className="form-control"
                />
              </div>
              <div className="col-sm-4 col-xs-12">
                <select
                  name="route"
                  value={this.props.filters.route}
                  onChange={this.props.handleFilterChange}
                  className="form-control"
                >
                  <option value="">All Drivers</option>
                  {Object.keys(this.props.driverList).map((driver) => (
                    <option key={driver} value={this.props.driverList[driver]}>
                      {this.props.driverList[driver]}
                    </option>
                  ))}
                </select>
              </div>
              <Col xs={12} sm={2}>
                <select
                  name="status"
                  value={this.props.filters.status}
                  onChange={this.props.handleFilterChange}
                  className="form-control"
                >
                  <option value="">All Fridges(Live & Offline)</option>
                  <option value="LIVE">Live Fridges</option>
                  <option value="OFFLINE">Offline Fridges</option>
                </select>
              </Col>
              <Col xs={12} sm={2}>
                <select
                  name="prod"
                  value={this.props.filters.prod}
                  onChange={this.props.handleFilterChange}
                  className="form-control"
                >
                  <option value="">Any Allocation Status</option>
                  <option value="1">Allocation On</option>
                  <option value="0">Allocation Off</option>
                </select>
              </Col>
            </div>
            <ListGroup>{renderLocationsList(this.filterFridges())}</ListGroup>
          </>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="listLocations">
        <div id="alertBox">
          <Modal show={this.props.alertModal.mode}>
            <Modal.Body>
              <div className="form-group">{this.props.alertModal.text}</div>
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                type="button"
                className="btn btn-warning"
                onClick={this.props.onClick}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>
        {this.renderLocations()}
      </div>
    );
  }
}
